/* Connect Send to the Backend */
import { connect } from 'react-redux';
import Send from './Send';
import * as sendactions from './Actions';



const mapStateToProps = state => ({
    sends: state.sends,
    currentsenduser: state.currentsenduser,
    sendlist: state.sendlist,
});

const mapDispatchToProps = dispatch => ({
    pwGetSends: (senduser) => {
        dispatch(sendactions.pwGetSends(senduser)).then((response) => {
         !response.error ? 
         dispatch(sendactions.pwGetSendsSuccess(response.value.data)) :
         dispatch(sendactions.pwGetSendsFailure(response.value.data))
        });
     }
});



const SendConnectContainer =  connect(mapStateToProps, mapDispatchToProps)(Send);

export default SendConnectContainer;


// WEBPACK FOOTER //
// ./src/SendConnectContainer.js